var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.7001H1.35V17.0001H2V16.3501V15.7001ZM2 16.3501V17.0001H16V16.3501V15.7001H2V16.3501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99961 12C1.99961 11.641 1.70859 11.35 1.34961 11.35C0.990624 11.35 0.699609 11.641 0.699609 12H1.34961H1.99961ZM1.34961 17H1.99961L1.99961 12H1.34961H0.699609L0.699609 17H1.34961Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 12C15.9996 11.641 15.7086 11.35 15.3496 11.35C14.9906 11.35 14.6996 11.641 14.6996 12H15.3496H15.9996ZM15.3496 17H15.9996V12H15.3496H14.6996V17H15.3496Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53033 0.46967C8.23744 0.176777 7.76256 0.176777 7.46967 0.46967L2.6967 5.24264C2.40381 5.53553 2.40381 6.01041 2.6967 6.3033C2.98959 6.59619 3.46447 6.59619 3.75736 6.3033L8 2.06066L12.2426 6.3033C12.5355 6.59619 13.0104 6.59619 13.3033 6.3033C13.5962 6.01041 13.5962 5.53553 13.3033 5.24264L8.53033 0.46967ZM8 13H8.75L8.75 1H8H7.25L7.25 13H8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.eeab7a251201e750813c67c88d6da33e.svg";
export { ForwardRef as ReactComponent };